export default __webpack_public_path__ + "static/media/feature_2.013503a0.jpg";